import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const CheckCircleIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  function CheckCircleIcon(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m12 23.938c-6.5929 0-11.938-5.3446-11.938-11.938 0-6.5929 5.3446-11.938 11.938-11.938 6.5929 0 11.938 5.3446 11.938 11.938 0 6.5929-5.3446 11.938-11.938 11.938zm0-2.6528c5.1278 0 9.2847-4.1569 9.2847-9.2847s-4.1569-9.2847-9.2847-9.2847-9.2847 4.1569-9.2847 9.2847 4.1569 9.2847 9.2847 9.2847zm-1.5885-7.9291 5.1918-6.1874c0.47087-0.56116 1.3075-0.63436 1.8687-0.16349l0.026744 0.022441c0.55061 0.46201 0.63303 1.2785 0.18586 1.8413l-5.7424 7.2265c-0.028222 0.044973-0.059443 0.088738-0.093696 0.13104-0.461 0.56929-1.2962 0.65708-1.8655 0.19607l-4.1232-3.3389c-0.56929-0.461-0.65708-1.2962-0.19608-1.8655 0.461-0.56929 1.2962-0.65708 1.8655-0.19607l2.8823 2.334z" />
      </SvgIcon>
    )
  },
)

export default CheckCircleIcon
